import { fetcher } from '@commenda/utils';
import { BASE_URL } from './helpers';

export async function duplicateDocumentTemplateVersion(
  documentTemplateId: string,
  documentTemplateVersionId: string
): Promise<{
  success: boolean;
  data?: { documentTemplateVersion: { id: string } };
}> {
  try {
    const res = await fetcher(
      `${BASE_URL}/${documentTemplateId}/version/${documentTemplateVersionId}/duplicate`,
      {
        method: 'POST',
      }
    );
    if (!res.ok) return { success: false, data: undefined };
    const responseData = (await res.json()) as {
      documentTemplateVersion: { id: string };
    };
    return {
      success: true,
      data: responseData,
    };
  } catch (err) {
    console.error(err);
    return { success: false, data: undefined };
  }
}
